var utils = {
	arr: ['test1', 'test2']
};




var app = exports = module.exports = {};

app.utils = utils;



